import React from "react";
import { format, isValid, parseISO } from "date-fns";

const DateTime = ({ value, warn, empty, stringFormat = "dd/MM/yyyy HH:mm" }) => {
  if (warn && !isValid(parseISO(value))) {
    return warn;
  }

  if (value && isValid(parseISO(value))) {
    return format(parseISO(value), stringFormat);
  }

  return empty || " ";
};

export const formatarData = (value, stringFormat) => {
  if (value && isValid(parseISO(value))) {
    return format(parseISO(value), stringFormat ?? "dd/MM/yyyy");
  }

  return "-";
};

export const DataExtenso = ({ value }) => {
  const dataConv = new Date(value);

  const day = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"][
    dataConv.getDay()
  ];
  const date = dataConv.getDate();
  const month = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ][dataConv.getMonth()];
  const year = dataConv.getFullYear();

  return (
    <p>
      {day}, {date} de {month} de {year}
    </p>
  );
};

export const Data = ({ value, empty }) => {
  const dataFormatada = formatarData(value);
  return (dataFormatada === "-" ? empty : dataFormatada) || "-";
};

export const RetornaDataToNumero = (data) => {
  const objData = new Date(data);
  const retornaApenasData = new Date(objData.getFullYear(), objData.getMonth(), objData.getDate(), 0, 0, 0);
  return Date.parse(retornaApenasData) || 0;
};

export default DateTime;
